<template>
  <div
    slot="footer"
    class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
  >
    <div class>
      <p class="card-category">
        {{ $t('table.showing') }} {{ froms + 1 }} {{ $t('table.to') }}
        {{ tos }} {{ $t('table.of') }} {{ totals }} {{ $t('table.entries') }}
      </p>
    </div>
    <l-pagination
      class="pagination-no-border"
      v-model="pagination.currentPage"
      :per-page="pagination.perPage"
      :total="pagination.total"
      pageFirst="false"
      pageLast="false"
    ></l-pagination>
  </div>
</template>

<script>
import Tables from 'src/class/Tables';
import { Pagination as LPagination } from 'src/components/index';

export default {
  name: 'card-footer',
  components: {
    LPagination,
  },
  props: {
    propPagination: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pagination: this.propPagination
        ? this.propPagination
        : Tables.Table.pagination,
      froms: 0,
      tos: 0,
      totals: 0,
    };
  },
};
</script>
